// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as React$1 from "motion/react";
import * as TailwindMerge from "tailwind-merge";
import * as JsxPPXReactSupportC from "rescript/lib/es6/jsxPPXReactSupportC.js";
import * as Motion$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/Motion.res.mjs";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V3RefManager$LiteracyplanetTupperware from "./V3RefManager.res.mjs";
import * as ResponseScore$LiteracyplanetTupperware from "../ResponseScore.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V3TutorialContext$LiteracyplanetTupperware from "./V3TutorialContext.res.mjs";
import * as V3StylePreferences$LiteracyplanetTupperware from "./V3StylePreferences.res.mjs";

function V3ProgressBar$ButtonAnimation(props) {
  return React.createElement(Motion$LiteracyplanetClientFlags.Button.make, {
              whileTap: {
                scale: 0.9
              },
              whileHover: {
                scale: 1.2
              },
              className: props.className,
              onClick: Caml_option.some(props.onClick),
              children: props.children
            });
}

var ButtonAnimation = {
  make: V3ProgressBar$ButtonAnimation
};

function V3ProgressBar$MarkAnimation(props) {
  return React.createElement(Motion$LiteracyplanetClientFlags.Inview.make, {
              children: React.createElement(Motion$LiteracyplanetClientFlags.Div.make, {
                    variants: {
                      offscreen: {
                        scale: 2
                      },
                      onscreen: {
                        scale: 1,
                        transition: {
                          type: "spring",
                          bounce: 0.5,
                          duration: 2
                        }
                      }
                    },
                    children: Caml_option.some(props.children)
                  })
            });
}

var MarkAnimation = {
  make: V3ProgressBar$MarkAnimation
};

function V3ProgressBar$ProgressButton(props) {
  var questionIndex = props.questionIndex;
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onChangeQuestion = match.onChangeQuestion;
  var currentQuestionIndex = match.currentQuestionIndex;
  var answerShape = Curry._1(match.getMarkState, questionIndex);
  var match$1;
  if (typeof answerShape !== "object") {
    match$1 = [
      undefined,
      undefined
    ];
  } else {
    var answerShape$1 = answerShape._0;
    var match$2 = answerShape$1.responsesCorrect;
    var match$3 = answerShape$1.responsesComplete;
    match$1 = [
      answerShape$1.questionCorrect,
      match$2 !== undefined && match$3 !== undefined ? ResponseScore$LiteracyplanetTupperware.calculateAccuracy(match$2, match$3) * 100.0 : undefined
    ];
  }
  var responseAccuracy = match$1[1];
  var answer = match$1[0];
  if (answer !== undefined) {
    if (answer) {
      return React.createElement(V3ProgressBar$ButtonAnimation, {
                  onClick: (function (param) {
                      Curry._1(onChangeQuestion, questionIndex);
                    }),
                  className: TailwindMerge.twMerge("progress-bar-button-correct", currentQuestionIndex === questionIndex ? "progress-bar-button-inner-selected" : ""),
                  children: React.createElement(V3ProgressBar$MarkAnimation, {
                        children: React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                              className: ""
                            })
                      })
                });
    } else if (responseAccuracy !== undefined) {
      return React.createElement(V3ProgressBar$ButtonAnimation, {
                  onClick: (function (param) {
                      Curry._1(onChangeQuestion, questionIndex);
                    }),
                  className: TailwindMerge.twMerge("progress-bar-button-incorrect", currentQuestionIndex === questionIndex ? "progress-bar-button-inner-selected" : ""),
                  children: React.createElement(V3ProgressBar$MarkAnimation, {
                        children: React.createElement("div", {
                              className: "progress-bar-button-accuracy"
                            }, String(responseAccuracy | 0), "%")
                      })
                });
    } else {
      return React.createElement(V3ProgressBar$ButtonAnimation, {
                  onClick: (function (param) {
                      Curry._1(onChangeQuestion, questionIndex);
                    }),
                  className: TailwindMerge.twMerge("progress-bar-button-incorrect", currentQuestionIndex === questionIndex ? "progress-bar-button-inner-selected" : ""),
                  children: React.createElement(V3ProgressBar$MarkAnimation, {
                        children: React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                              className: ""
                            })
                      })
                });
    }
  } else {
    return React.createElement(V3ProgressBar$ButtonAnimation, {
                onClick: (function (param) {
                    Curry._1(onChangeQuestion, questionIndex);
                  }),
                className: TailwindMerge.twMerge("progress-bar-button", currentQuestionIndex === questionIndex ? "progress-bar-button-inner-selected" : "progress-bar-button-inner"),
                children: String(questionIndex + 1 | 0)
              });
  }
}

var ProgressButton = {
  make: V3ProgressBar$ProgressButton
};

function V3ProgressBar$ProgressBar(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  return React.createElement(React.Fragment, {}, React.createElement("div", {
                  className: "progress-background"
                }), React.createElement("div", {
                  className: "progress-bar-line-container"
                }, React.createElement("div", {
                      className: "progress-bar-line"
                    })), React.createElement("div", {
                  className: "progress-bar-line-container"
                }, React.createElement(Motion$LiteracyplanetClientFlags.Div.make, {
                      style: {
                        scaleX: props.scaleX,
                        originX: 0
                      },
                      className: "progress-bar-line-inner"
                    })), React.createElement("div", {
                  className: "progress-bar-line-container"
                }, React.createElement("div", undefined, Belt_Array.map(Belt_Array.makeBy(match.questionCount, (function (i) {
                                return i + 1 | 0;
                              })), (function (i) {
                            return JsxPPXReactSupportC.createElementWithKey(String(i) + "-circle3", V3ProgressBar$ProgressButton, {
                                        questionIndex: i - 1 | 0
                                      });
                          })))));
}

var ProgressBar = {
  make: V3ProgressBar$ProgressBar
};

function V3ProgressBar$AnimateScrollbar(props) {
  return React.createElement(Motion$LiteracyplanetClientFlags.Div.make, {
              animate: {
                transform: props.hide ? "translateY(-6rem)" : "translateY(0px)"
              },
              transition: {
                type: "spring",
                duration: 1
              },
              className: "progress-container",
              children: Caml_option.some(React.createElement(V3ProgressBar$ProgressBar, {
                        scaleX: props.scaleX
                      }))
            });
}

var AnimateScrollbar = {
  make: V3ProgressBar$AnimateScrollbar
};

function useScrollTimout(scaleX) {
  var match = React.useState(function (param) {
        return false;
      });
  var setIdle = match[1];
  var match$1 = React.useState(function (param) {
        return 0;
      });
  var setPoll = match$1[1];
  var running = React.useRef("Idle");
  React.useEffect((function (param) {
          var match = running.current;
          var id;
          switch (match) {
            case "Scrolling" :
                running.current = "CheckIfScrolling";
                id = Caml_option.some(setTimeout((function (param) {
                            Curry._1(setPoll, (function (i) {
                                    return i + 1 | 0;
                                  }));
                          }), 1000));
                break;
            case "CheckIfScrolling" :
                running.current = "Idle";
                Curry._1(setIdle, (function (param) {
                        return true;
                      }));
                id = undefined;
                break;
            case "StoppedScrolling" :
                throw {
                      RE_EXN_ID: "Match_failure",
                      _1: [
                        "V3ProgressBar.res",
                        184,
                        13
                      ],
                      Error: new Error()
                    };
            case "Idle" :
                id = undefined;
                break;
            
          }
          return Belt_Option.map(id, (function (id, param) {
                        clearTimeout(id);
                      }));
        }), [match$1[0]]);
  React$1.useMotionValueEvent(scaleX, "change", (function (a) {
          var match = running.current;
          switch (match) {
            case "Scrolling" :
                return ;
            case "CheckIfScrolling" :
                running.current = "Scrolling";
                return ;
            case "StoppedScrolling" :
                throw {
                      RE_EXN_ID: "Match_failure",
                      _1: [
                        "V3ProgressBar.res",
                        202,
                        4
                      ],
                      Error: new Error()
                    };
            case "Idle" :
                running.current = "Scrolling";
                Curry._1(setPoll, (function (i) {
                        return i + 1 | 0;
                      }));
                return Curry._1(setIdle, (function (param) {
                              return false;
                            }));
            
          }
        }));
  return match[0];
}

function V3ProgressBar$RetractableScrollbar(props) {
  var scaleX = props.scaleX;
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var idle = useScrollTimout(scaleX);
  var match$1 = Curry._1(match.getMarkState, match.currentQuestionIndex);
  var notMarked;
  notMarked = typeof match$1 !== "object" ? true : false;
  return React.createElement(V3ProgressBar$AnimateScrollbar, {
              scaleX: scaleX,
              hide: idle && notMarked
            });
}

var RetractableScrollbar = {
  make: V3ProgressBar$RetractableScrollbar
};

function V3ProgressBar(props) {
  var scaleX = props.scaleX;
  var match = Curry._1(V3TutorialContext$LiteracyplanetTupperware.use, undefined);
  var match$1 = V3StylePreferences$LiteracyplanetTupperware.usePrefs();
  return React.createElement(V3RefManager$LiteracyplanetTupperware.PortalImmediate.make, {
              id: "progressBar",
              children: React.createElement("div", {
                    className: TailwindMerge.twMerge("relative", match.state === "ReadingTutorial" ? "hidden" : "")
                  }, match$1.progressRetract ? React.createElement(V3ProgressBar$RetractableScrollbar, {
                          scaleX: scaleX
                        }) : React.createElement(V3ProgressBar$AnimateScrollbar, {
                          scaleX: scaleX,
                          hide: false
                        }))
            });
}

var Motion;

var hideProgressTimeout = 1000;

var make = V3ProgressBar;

export {
  Motion ,
  ButtonAnimation ,
  MarkAnimation ,
  ProgressButton ,
  ProgressBar ,
  AnimateScrollbar ,
  hideProgressTimeout ,
  useScrollTimout ,
  RetractableScrollbar ,
  make ,
}
/* react Not a pure module */
